<template>
  <main>
    <HeroSection />
    <ProblemSection />
    <SolutionSection />
    <HowItWorksSection />
    <CaseStudySection />
    <WhoWeServeSection />
    <FeatureGridSection />
    <PricingSection />
    <TestimonialsSection />
    <FAQSection :openFaqs="openFaqs" :toggleFaq="toggleFaq" />
  </main>
</template>

<script setup>
import { ref } from 'vue';

import HeroSection from '../components/HeroSection.vue';
import ProblemSection from '../components/ProblemSection.vue';
import SolutionSection from '../components/SolutionSection.vue';
import HowItWorksSection from '../components/HowItWorksSection.vue';
import CaseStudySection from '../components/CaseStudySection.vue';
import WhoWeServeSection from '../components/WhoWeServeSection.vue';
import FeatureGridSection from '../components/FeatureGridSection.vue';
import PricingSection from '../components/PricingSection.vue';
import TestimonialsSection from '../components/TestimonialsSection.vue';
import FAQSection from '../components/FAQSection.vue';

const openFaqs = ref([false, false, false, false, false, false, false, false]);

const toggleFaq = (index) => {
  openFaqs.value[index] = !openFaqs.value[index];
};
</script>
